/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import BloodInventoryRequestMap from './blood-inventory-request-map';
import BloodInventoryRequestMapDetail from './blood-inventory-request-map-detail';
import BloodInventoryRequestMapUpdate from './blood-inventory-request-map-update';
import BloodInventoryRequestMapDeleteDialog from './blood-inventory-request-map-delete-dialog';

const BloodInventoryRequestMapRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<BloodInventoryRequestMap />} />
    <Route path="new" element={<BloodInventoryRequestMapUpdate />} />
    <Route path=":id">
      <Route index element={<BloodInventoryRequestMapDetail />} />
      <Route path="edit" element={<BloodInventoryRequestMapUpdate />} />
      <Route path="delete" element={<BloodInventoryRequestMapDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default BloodInventoryRequestMapRoutes;
